import { render, staticRenderFns } from "./recycleMyGoodsItem.vue?vue&type=template&id=374cf551&scoped=true&"
import script from "./recycleMyGoodsItem.vue?vue&type=script&lang=ts&"
export * from "./recycleMyGoodsItem.vue?vue&type=script&lang=ts&"
import style0 from "./recycleMyGoodsItem.vue?vue&type=style&index=0&id=374cf551&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374cf551",
  null
  
)

export default component.exports